import { render, staticRenderFns } from "./FAQSearch.vue?vue&type=template&id=9ad0535e&scoped=true&"
import script from "./FAQSearch.vue?vue&type=script&lang=ts&"
export * from "./FAQSearch.vue?vue&type=script&lang=ts&"
import style0 from "./FAQSearch.vue?vue&type=style&index=0&id=9ad0535e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ad0535e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VForm,VRow,VSheet,VSpacer})
